import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { Checkbox } from '@marriott/mi-ui-library-shop';

export const StyledFlexibleDateCheckBox = styled(Checkbox)`
  ${rtl`
  font-family: ${theme.fontFamily.swiss};
  line-height: ${toRem(18)};
  font-size: ${toRem(14)};
  font-weight: 700;
  input[type='checkbox'] + span {
    color: ${theme.color['black']};
  }
  label {
    color: ${theme.color['black']};
  }
  @media ${theme.mediaQuery.tablet} {
    font-size: ${toRem(14)};
    font-family: ${theme.fontFamily.swiss};
    line-height: ${toRem(18)};
    font-weight: 500;
  }
`}
`;
